<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <div class="modal-title">
      <span>Aging Reminders for Invoice: {{ data?.invoiceNumber }}</span>
    </div>
  </kendo-dialog-titlebar>

  <div class="p-16" *ngIf="reminders?.length; else noReminders" class="invoice-info-sidebar">
    <kendo-panelbar [expandMode]="2" *ngFor="let reminder of reminders" class="mb-16">
      <kendo-panelbar-item [title]="'Sent Date: ' + (reminder?.dateSent | customDate: 'MM/dd/yyyy hh:mm a')"
        [expanded]="true">
        <ng-template kendoPanelBarContent>
          <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 12, cols: 0}" [cols]="['repeat(4,minmax(0,1fr))']"
            class="p-12">
            <kendo-gridlayout-item class="mb-0">
              <h6><small>Template</small></h6>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3" class="mb-0">
              <p class="font-weight600">{{ reminder?.emailTemplate || '-' }}</p>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item class="mb-0">
              <h6><small>Customer Name</small></h6>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3" class="mb-0">
              <p class="font-weight600">{{ reminder?.customerName || '-' }}</p>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item class="mb-0">
              <h6><small>Emails</small></h6>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3" class="mb-0">
              <p class="font-weight600">{{ reminder?.emails || '-' }}</p>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item class="mb-0">
              <h6><small>Status</small></h6>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3" class="mb-0">
              <p class="font-weight600">{{ reminder?.status || '-' }}</p>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item class="mb-0 no-border">
              <h6><small>Sent By</small></h6>
            </kendo-gridlayout-item>
            <kendo-gridlayout-item [colSpan]="3" class="mb-0 no-border">
              <p class="font-weight600">{{ reminder?.CreatedBy | fullName }}</p>
            </kendo-gridlayout-item>
          </kendo-gridlayout>
        </ng-template>
      </kendo-panelbar-item>
    </kendo-panelbar>
  </div>
</div>
<ng-template #noReminders>
  <div class="text-center p-24">
    <p>No aging reminders found for this invoice.</p>
  </div>
</ng-template>
